import { CustomerType } from "features/customer/enums/customerType";
import { FormValidations } from "features/shared/forms/hooks/useForm";
import FunctionValidationRule from "features/validation/rules/FunctionValidationRule";

export const ets2AffidavitFormValidations = (
  customerType: CustomerType
): FormValidations => {
  const basicValidations = getBasicValidations();
  let companyValidations: FormValidations = {};

  if (customerType === "Company") {
    companyValidations = getCompanyValidations();
  }

  return {
    ...basicValidations,
    ...companyValidations,
  };
};

const getBasicValidations = (): FormValidations => {
  return {
    DESC_ETS2_TYP_SPOTREBY: { required: true, type: "OnlyRequired" },
    DESC_ETS2_ROK: { required: true, type: "OnlyRequired" },
    DESC_ETS2_OPM: { required: true, type: "OnlyRequired" },
    DESC_ETS2_TYP_PODNIKANI: { required: true, type: "OnlyRequired" },
  };
};

const getCompanyValidations = (): FormValidations => {
  return {
    DESC_ETS2_POVERENA_OSOBA_JMENO: { required: true, type: "OnlyRequired" },
    DESC_ETS2_POVERENA_OSOBA_PRIJMENI: { required: true, type: "OnlyRequired" },
    DESC_ETS2_POVERENA_OSOBA_POZICE: { required: true, type: "OnlyRequired" },
    DESC_ETS2_POVERENA_OSOBA_OPRAVNEN_JEDNAT: {
      type: "Function",
      validate: (value: any) => value === true || value === false,
      message: "required",
    } as FunctionValidationRule,
  };
};
